"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeWindow = void 0;
exports.safeWindow = typeof window !== "undefined" ? window : {};
//# sourceMappingURL=browserConstants.js.map